import {
  ADVERT_FORMAT_TYPES,
  DAY_VIEW_PLACEMENTS,
  SPONSORED_SERVICE_PRIORITY,
} from '@web-platform/shared-universal-constants/src/adverts';
import { ADVERT } from '@web-platform/shared-universal-constants/src/flightsResults';

import type { RadarCreative } from '@web-platform/shared-universal-types/src/network/endpoints/radar/radarCreativeTypes';
import type {
  Advert,
  ConductorCreative,
} from '@web-platform/shared-universal-types/src/redux/acorn/state/flightsDayView/entitiesSearchResults/adverts/types';
import type { CombinedResultsFlightsInlineAdvert } from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/combinedResultsFlightsInline';
import type { AdvertItineraryMap } from '@web-platform/shared-universal-types/src/redux/state/entities/flights/adverts';

export const isAllowedCreative = (creative: RadarCreative | ConductorCreative) => {
  if ('analyticsProperties' in creative) {
    return (
      creative.analyticsProperties.id_placement !== DAY_VIEW_PLACEMENTS.MOBILE ||
      creative.idFormat !== ADVERT_FORMAT_TYPES.PACKAGES_INLINE
    );
  }

  return (
    creative.analytics_properties.id_placement !== DAY_VIEW_PLACEMENTS.MOBILE ||
    creative.id_format !== ADVERT_FORMAT_TYPES.PACKAGES_INLINE
  );
};

export type VisibleAdvertItem = {
  id: string;
  key: string;
  itineraryId: string | null;
  position: number;
  type: typeof ADVERT;
};

export const buildVisibleAdvertItems = ({
  advertIds,
  advertItineraryMap,
  adverts,
  intervalBetweenAds,
}: {
  advertIds: readonly string[];
  adverts: Record<string, Advert | CombinedResultsFlightsInlineAdvert>;
  advertItineraryMap: AdvertItineraryMap;
  intervalBetweenAds: number;
}): VisibleAdvertItem[] => {
  const visibleAdvertIds = advertIds.filter((advertId) => {
    const { creative } = adverts[advertId];
    const hasItineraryId = Boolean(creative && 'itineraryId' in creative && creative.itineraryId);
    return !hasItineraryId || Boolean(advertItineraryMap[advertId]);
  });

  const firstAdIsHouse =
    visibleAdvertIds.length >= 1 &&
    adverts[visibleAdvertIds[0]]?.analyticsProperties.priority === SPONSORED_SERVICE_PRIORITY.HOUSE;
  const houseOffset = firstAdIsHouse ? 1 : 0;

  return visibleAdvertIds.map((id, index) => {
    const advert = adverts[id];
    // A house ad at the top of the list takes the first position after p1
    // (i.e. p[intervalBetweenAds+1]) rather than being squashed to p1.
    return {
      id,
      key: `${id}-${advert.analyticsProperties.idTracking}`,
      itineraryId: advertItineraryMap[id] || null,
      position: (index + houseOffset) * intervalBetweenAds + 1,
      type: ADVERT,
    };
  });
};
